<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>数据管理</el-breadcrumb-item>
      <el-breadcrumb-item>数据列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-input
            placeholder="请输入内容"
            clearable
            v-model="queryInfo.query"
            @clear="handleCurrentChange(1);"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="
                handleCurrentChange(1);
              "
            ></el-button>
          </el-input>
        </el-col>
      </el-row>

      <el-table :data="datalist" stripe border style="width: 100%" v-loading="loading">
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="data_id" label="数据编号"></el-table-column>
        <el-table-column prop="data_name" label="数据名称" width="200"></el-table-column>
        <el-table-column prop="age" label="年龄" width="100"></el-table-column>
        <el-table-column prop="upload_user" label="上传用户" width="100"></el-table-column>
        <el-table-column label="上传时间" width="200">
          <template v-slot="scope">{{ scope.row.upload_time }}</template>
        </el-table-column>
        <el-table-column prop="data_dimen" label="数据维度" width="100"></el-table-column>
        <el-table-column prop="box" label="裁剪" width="160"></el-table-column>
        <el-table-column label="下载数据" min-width="80">
          <template v-slot="scope">
            <el-button size="mini" type="primary" @click="downloadOriginalData(scope.row.data_id)">
              <i class="el-icon-download"></i>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="AI建模" min-width="80">
          <template v-slot="scope">
            <span v-if="scope.row.ai_status === '0'">未运行</span>
            <span v-if="scope.row.ai_status === '1'">计算中</span>
            <span v-if="scope.row.ai_status === '2'">
              <el-button size="mini" type="primary" @click="downloadAIData(scope.row.data_id)">
                <i class="el-icon-download"></i>
              </el-button>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="AI完成时间" min-width="130">
          <template v-slot="scope">
            <span v-if="scope.row.ai_finish_time === null">未完成</span>
            <span v-if="scope.row.ai_finish_time !== null">{{ scope.row.ai_finish_time }}</span>
          </template>
        </el-table-column>
        <el-table-column label="AI预览" width="70">
          <template v-slot="scope">
            <span v-if="scope.row.ai_finish_time !== null">
              <a :href="'/STLViewer/model.html?dataid='+scope.row.data_id+'&type=0'" target="_blank">预览</a>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="process_user" label="处理人">
          <template v-slot="scope">
            <span v-if="scope.row.process_user === null">无</span>
            <span v-if="scope.row.process_user !== null">{{scope.row.process_user}}</span>
          </template>
        </el-table-column>
        <el-table-column label="完成时间" min-width="140">
          <template v-slot="scope">
            <span v-if="scope.row.finish_time === null">无</span>
            <span v-if="scope.row.finish_time !== null">{{ scope.row.finish_time }}</span>
          </template>
        </el-table-column>
        <el-table-column label="模型下载" min-width="80">
          <template v-slot="scope">
            <span v-if="scope.row.finish_time === null">无</span>
            <span v-if="scope.row.finish_time !== null">
              <el-button size="mini" type="primary" @click="downloadSTLs(scope.row.data_id)">
                <i class="el-icon-download"></i>
              </el-button>
            </span>
          </template>
        </el-table-column>
        
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[5, 15, 20]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      queryInfo: {
        query: "",
        pagenum: 1,
        pagesize: 5,
      },
      datalist: [],
      total: 0,
    };
  },
  methods: {
    async getDataList() {
      this.loading = true;
      const { data } = await this.$http.post("data/datalist", this.queryInfo);
      if (data.status === 100) {
        this.datalist = data.data.list;
        this.total = data.data.total;
        this.loading = false;
      }
    },
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize;
      this.queryInfo.pagenum = 1;
      this.getDataList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage;
      this.getDataList();
    },
    downloadSTLs(dataid) {
      this.$message({message: "正在生成压缩包",type: "success"});
      let baseurl = this.$http.defaults.baseURL;
      window.location = baseurl + "/data/downloadSTL/" + dataid + "/11111111";
    },
    downloadAIData(data_id) {
      this.$message({message: "正在生成压缩包",type: "success"});
      let baseurl = this.$http.defaults.baseURL;
      window.location = baseurl + "/data/aistl/" + data_id + "/11111111";
    },
    downloadOriginalData(data_id) {
      let baseurl = this.$http.defaults.baseURL;
      window.location = baseurl + "/data/dicomzip/" + data_id;
    }
  },
  created() {
    this.getDataList();
  },
};
</script>

<style lang="less" scoped>
.el-cascader {
  width: 100%;
}
.cardiacCheckbox {
  display: block;
  margin-left: 20px;
  margin-top: 10px;
}
</style>
